<template>

  <v-card flat max-width="1000">
        <v-skeleton-loader
            type="button, card-heading"
        ></v-skeleton-loader>

        <v-skeleton-loader
            class="ml-10"
            type="list-item-two-line,list-item-two-line"
        ></v-skeleton-loader>

        <v-skeleton-loader
            type="card-heading"
        ></v-skeleton-loader>

        <v-skeleton-loader
            class="ml-10"
            type="list-item-two-line,list-item-two-line,list-item-two-line,list-item-two-line,list-item-two-line"
        ></v-skeleton-loader>
  </v-card>

</template>

<script>

export default {

    props: {
        value: {
            type: Boolean,
            default: false,
        }
    },
}

</script>